import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import get from 'lodash.get'
import SydModal from '../../../commonDesign/SydModal'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { useFormattingContext } from '../../FormattingProvider/FormattingContext'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { createResourceUrl } from '../../../../hooks/usePublicResource'
import { useAppContext } from '../../../../redux/slices/appContext'

const useStyles = makeStyles({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--padding-md)',
    maxHeight: '70vh',
    overflow: 'auto'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 'var(--padding-md)'
  },
  imagePlaceholder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '120px',
    height: '120px',
    background: 'var(--color-neutral-300)',
    borderRadius: '50%',
    margin: '0 auto var(--padding-md)',
    border: '3px solid var(--color-neutral-500)',
    color: 'var(--color-neutral-500)'
  },
  image: {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid var(--color-neutral-500)'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--padding-xs)',
    padding: 'var(--padding-md)',
    borderRadius: 'var(--border-radius-md)',
    backgroundColor: 'var(--theme-color-surface-d1)'
  },
  label: {
    fontSize: 'var(--font-size-xs)',
    fontWeight: 600,
    color: 'var(--theme-color-on-surface-d0-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  value: {
    fontSize: 'var(--font-size-md)',
    color: 'var(--theme-color-on-surface-d0)',
    lineHeight: 1.5
  }
})

export const PersonDetails = ({ open, onClose, entityProps, nodeData }) => {
  const { firmId } = useAppContext()
  const { formatter } = useFormattingContext()
  const { state: { config } } = useEntityGraphContext()
  const classes = useStyles()
  const person = entityProps?.data

  const detailDisplayValues = useMemo((value) => {
    return (config?.detailDisplayValues[200] ?? [{
      accessor: 'firstName',
      label: 'First Name'
    }, {
      accessor: 'lastName',
      label: 'Last Name'
    }]).map((displayValue) => {
      const rawValue = get(person, displayValue.accessor)
      let formattedValue = rawValue
      if (displayValue.display === 'image') {
        formattedValue = rawValue?.length && !rawValue.startsWith('http') ? createResourceUrl({
          firmId,
          identifier: rawValue
        }) : rawValue

        // eslint-disable-next-line no-debugger
        debugger
      }
      if (displayValue.format) {
        formattedValue = formatter(rawValue, displayValue.format)
      }

      return {
        ...displayValue,
        value: formattedValue
      }
    })
  }, [config?.detailDisplayValues, firmId, formatter, person])

  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Details'
      maxWidth='sm'
      fullWidth
    >
      <div className={classes.modalContent}>
        {detailDisplayValues?.map((displayValue) => {
          if (displayValue.display === 'image') {
            return displayValue.value?.length ? (
              <div key={displayValue.accessor} className={classes.imageContainer}>
                <img src={displayValue.value} alt={person.label} className={classes.image} />
              </div>
            ) : (
              <div key={displayValue.accessor} className={classes.imagePlaceholder}>
                <Icon name={ICON_NAMES.user} customSize={48} />
              </div>
            )
          }
          return (
            <div key={displayValue.accessor} className={classes.field}>
              <div className={classes.label}>{displayValue.label}</div>
              <div className={classes.value}>{displayValue.value || '-'}</div>
            </div>
          )
        })}
      </div>
    </SydModal>
  )
}

PersonDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  entityProps: PropTypes.object,
  nodeData: PropTypes.object
}
